module.exports = __webpack_public_path__ + "img/fish.5acedbc1.gif";